export default "__VITE_ASSET__BfUTfDlE__"